import io from 'socket.io-client';
import socketHandlers from './socketHandlers';
import getTokens from './getTokens';


const {
  socketConnect,
  socketDisconnect,
  socketReconnect,
  socketError,
  receiveMessage,
  setUserTyping,
  messageStatus,
  setUserEndTyping,
} = socketHandlers;

const socketUrl = process.env.VUE_APP_SOCKET_URL;

const createSocket = () => {
  const tokens = getTokens();
  if (!tokens) return null;
  const ENDPOINT = `${socketUrl}?token=${JSON.parse(tokens).access}`;
  const socket = io(ENDPOINT, {
    transports: ['websocket'],
  });
  socket.on('connect', socketConnect);
  socket.on('disconnect', socketDisconnect);
  socket.on('reconnect', socketReconnect);
  socket.on('error', socketError);
  socket.on('message_saved', receiveMessage);
  socket.on('receive_message', receiveMessage);
  socket.on('message_read', messageStatus);
  socket.on('message_unread', messageStatus);
  socket.on('user_typing', setUserTyping);
  socket.on('user_end_typing', setUserEndTyping);
  return socket;
};

class SocketConnect {
  constructor() {
    if (!SocketConnect.instance) {
      SocketConnect.instance = createSocket();
    }
    return SocketConnect.instance;
  }
}

export default SocketConnect;
